<template>
   <transition name="modal" v-if="statusModalVideo">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
              <button class="close" @click="fecharVideo()">X</button>
          </div>
          <div class="modal-body">
            <iframe width="100%"  src="https://www.youtube.com/embed/KNe63GTMNsg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {


    data () {
        return {

        }
    },

    computed: {
        ...mapState({
            statusModalVideo: (state) => state.Layout.modalVideo
        })
    },

    methods: {
      ...mapActions({
          mostrarVideo: 'Layout/mostrarModalVideo'
      }),
      fecharVideo () {
          this.mostrarVideo(false)
      }
  }
}
</script>


<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 50%;
  margin: 0px auto;
  padding: 10px 20px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  @include media_tablet() {
    width: 100%;
  }
}

.modal-header  {
    display: flex;
    justify-content: flex-end;
   button {
       background-color: transparent;
       border: none;
       font-family: 'rubik_bold';
       font-size: 30px;
       text-align: right;
       color: #8fc74a;
   }
}


.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;

  iframe {
    height: 60vh;
    @include media_tablet() {
     height: 30vh;
    }
  }
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
